import { Grid } from "@mui/material";
import React from "react";
import Schedule from "../../components/ui/Doctor/Schedule";
import AppLayout from "../SideBar";

const DoctorSchedule = () => {
  return (
    <Grid container spacing={0}>
      <AppLayout>
        <Schedule />
      </AppLayout>
    </Grid>
  )
}

export default DoctorSchedule;